<template>
  <v-ons-page>

    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">{{ formTitle }}</div>
    </v-ons-toolbar>

    <div class="content">

      <section v-if="! isIframeLoaded" style="text-align: center; margin-top: 20px;">
        <v-ons-progress-circular :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
      </section>
      <iframe :src="formUrl" @load="isIframeLoaded = true" frameborder="0" style="width:100%; height: calc(100% - 4px);; border:none;"></iframe>

    </div>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';

export default {
  mixins: [mixinsCommons],
  props: ['pageStack'],
  data() {
    return {
      formTitle: '',
      formUrl: '',
      isIframeLoaded: false
    };
  },
  created() {
  }
};
</script>
